export enum FileTypes {
    UNKNOWN = -1,
    ALL = 0,
    IMAGE = 1,
    DOCUMENT = 2,
    VIDEO = 3,
    MEDIA = 4,
}
